import React, { useState, useRef, useEffect } from 'react';
import 'leaflet/dist/leaflet.css';
import { MapComponent_Page3 } from './components/MapComponent_Page3';
import { useNavigate } from 'react-router-dom';
import './shapp_p1.css';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Shapp_p3({ token }) {  // token passato come prop

    const mapRef = useRef(null);
    const navigate = useNavigate();

    const fileInputRef = useRef(null);

    const [infotabWidth, setInfotabWidth] = useState(280);
    const infotabRef = useRef(null);
    const startX = useRef(0);
    const startWidth = useRef(0);
    const [selectedMenu, setSelectedMenu] = useState('elab');
    const [selectedProject, setSelectedProject] = useState('');
    const [projects, setProjects] = useState([]);
    const [isMapClickActive, setIsMapClickActive] = useState(false);

    // Upload state
    const [file, setFile] = useState(null);
    const [projectName, setProjectName] = useState("");

    const toggleMapClick = () => setIsMapClickActive(prev => !prev);

    const handleProjectChange = (e) => {
        setSelectedProject(e.target.value);
        mapRef.current?.handleProjectChange(e);
    };

    // Fetch progetti
    const loadProjects = async () => {
        if (mapRef.current) {
            const projs = await mapRef.current.fetchProjects();
            setProjects(projs);
        }
    };

    useEffect(() => {
        loadProjects();
    }, []);



    // Resize infotab
    const handleMouseDown = (event) => {
        startX.current = event.clientX;
        startWidth.current = infotabRef.current.offsetWidth;

        const handleMouseMove = (e) => {
            const newWidth = Math.max(100, startWidth.current + (e.clientX - startX.current));
            setInfotabWidth(newWidth);
        };
        const handleMouseUp = () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    useEffect(() => {
        const handleResize = () => {
            if (infotabRef.current) {
                const handleWrapper = document.querySelector('.resize-handle');
                if (handleWrapper) {
                    handleWrapper.style.top = `${infotabRef.current.getBoundingClientRect().top}px`;
                    handleWrapper.style.height = `${infotabRef.current.clientHeight}px`;
                }
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [infotabWidth]);

    // Upload progetto
    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            // Rimuove estensione .json o .geojson
            const nameWithoutExt = selectedFile.name.replace(/\.geojson$/i, "").replace(/\.json$/i, "");
            setProjectName(nameWithoutExt);
        }
    };

    const handleUploadProject = async (selectedFile) => {
    const fileToUpload = selectedFile || file;
    if (!fileToUpload) {
        toast.error("Seleziona un file geoJSON da caricare", { autoClose: 2000 });
        return;
    }

    // Se projectName è vuoto, usa il nome del file senza estensione
    const name = projectName || fileToUpload.name.replace(/\.[^/.]+$/, "");

    const formData = new FormData();
    formData.append("project_name", name);
    formData.append("file", fileToUpload);

    try {
        const res = await axios.post(
            "https://www.hat.sofhare.com/shnapp-upload/",
            formData,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        toast.success(res.data.success, { autoClose: 1500 });

        setFile(null);
        setProjectName("");

        await loadProjects();
        setSelectedProject(name);
        mapRef.current?.handleProjectChange({ target: { value: name } });

    } catch (err) {
        console.error("Upload error:", err.response?.data || err.message);
        toast.error("Errore caricamento progetto!", { autoClose: 2000 });
    }
};

    const renderContent = () => {
        switch (selectedMenu) {
            case 'Download':
                return (
                    <div className="layout-buttons-container">
                        <select value={selectedProject} onChange={handleProjectChange} className="layout-select">
                            <option value="">Select a Project</option>
                            {projects.map((p, i) => <option key={i} value={p}>{p}</option>)}
                        </select>

                        <button onClick={() => mapRef.current?.downloadGeoJSON()} className="layout-button">
                            Download progetto
                        </button>

                        {/* Bottone unico per caricare il file */}
                        <button
                            className="layout-button"
                            onClick={() => fileInputRef.current?.click()}
                        >
                            Carica progetto
                        </button>

                        <input
                            type="file"
                            accept=".geojson"
                            style={{ display: "none" }}
                            ref={fileInputRef}
                            onChange={(e) => {
                                const selectedFile = e.target.files[0];
                                if (!selectedFile) return;

                                // Aggiorna lo state file e il projectName se necessario
                                handleFileChange({ target: { files: [selectedFile] } });

                                // Carica subito passando il file direttamente
                                handleUploadProject(selectedFile);
                            }}
                        />

                        <p>
                            In questa sezione puoi selezionare un progetto di riferimento e scaricarne il file json contenente le informazioni.
                            Il json può ad esempio essere caricato su Qgis per vedere i punti di prova.
                        </p>
                    </div>
                );

            case 'elab':
                return (
                    <div className="layout-buttons-container">
                        <select value={selectedProject} onChange={handleProjectChange} className="layout-select">
                            <option value="">Select a Project</option>
                            {projects.map((p, i) => <option key={i} value={p}>{p}</option>)}
                        </select>

                        <button onClick={toggleMapClick} className="layout-button">
                            {isMapClickActive ? "Disattiva click mappa" : "Attiva click mappa"}
                        </button>

                        <p>
                            In questa sezione puoi richiedere una nuova elaborazione. Utilizza un progetto che hai caricato per vedere i punti di prova,
                            cliccando sul punto potrai caricare i dati e effettuare la richiesta. Per aggiungere un nuovo punto invece clicca sul pulsante + e poi aggiungi il punto
                            sulla mappa.
                        </p>
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div>
            <ToastContainer />
            <div className="Principal">
                <div className="layoutapp">
                    <div className="infotab" ref={infotabRef} style={{ width: `${infotabWidth}px` }}>
                        <div className="Title-sh">Nuova elaborazione</div>
                        <hr className="divider" />
                        <div className="menu">
                            <ul>
                                <li onClick={() => setSelectedMenu('elab')} className={selectedMenu === 'elab' ? 'active' : ''}>Richiedi elaborazione</li>
                                <li onClick={() => setSelectedMenu('Download')} className={selectedMenu === 'Download' ? 'active' : ''}>Condividi progetto</li>
                            </ul>
                        </div>
                        {renderContent()}
                    </div>

                    <div className="App">
                        <MapComponent_Page3 ref={mapRef} mapClickActive={isMapClickActive} />
                        <div className="resize-handle" onMouseDown={handleMouseDown} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Shapp_p3;



